import styled from 'styled-components';
import Button from 'js/components/common/Button';

export default styled(Button)`
  margin-top: 2rem;
`;
